import { AnalyticsApplication } from "..";
import { ModuleCode } from '@reporting/rp-types/accounting';
import rp from "@reporting/rp-app-host";

const app = () => rp.applications.get<AnalyticsApplication>('analytics');

export function getModuleDefinition(m: ModuleCode) {
	return app().modules.get(m);
}

export function getModuleDefinitions() {
	return app().modules;
}
